import { render, staticRenderFns } from "./StagingInternalDiversion1Page.vue?vue&type=template&id=225535ba&scoped=true&"
import script from "./StagingInternalDiversion1Page.vue?vue&type=script&lang=js&"
export * from "./StagingInternalDiversion1Page.vue?vue&type=script&lang=js&"
import style0 from "./StagingInternalDiversion1Page.vue?vue&type=style&index=0&id=225535ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225535ba",
  null
  
)

export default component.exports